import type { Campaign } from '../campaignsApi';
import { campaignChannels } from '../campaignChannels';
import './campaign-channel-settings.css';

interface Props {
  campaign: Campaign;
  metaPending: boolean;
  googlePending: boolean;
  onSyncMeta: () => void;
  onSyncGoogle: () => void;
}

export function CampaignChannelActions(props: Props) {
  const channels = campaignChannels(props.campaign);
  return <div className="campaign-channel-actions">
    {channels.includes('meta') && props.campaign.meta_campaign_id && <button type="button"
      disabled={props.metaPending} onClick={props.onSyncMeta}>
      {props.metaPending ? 'Sincronizando Meta...' : 'Sincronizar Meta Ads'}
    </button>}
    {channels.includes('google') && props.campaign.google_campaign_id && <button type="button"
      disabled={props.googlePending} onClick={props.onSyncGoogle}>
      {props.googlePending ? 'Sincronizando Google...' : 'Sincronizar Google Ads'}
    </button>}
  </div>;
}
